import { useQuery } from '@tanstack/react-query';

import type { AuditLogFilters } from '../../../api/types';
import { fetchAuditLog } from '../api/auditLogApi';

// PARA-106, AC-9: queryKey включает фильтры — каждая комбинация кэшируется отдельно.
export function useAuditLog(filters: AuditLogFilters) {
  return useQuery({
    queryKey: ['admin', 'auditLog', filters] as const,
    queryFn: () => fetchAuditLog(filters),
  });
}
